import React from "react";
import ImgBackground from "../components/pngBackground/imageBackground";
import BackgroundImg from "../assets/images/corporateManagementImg.png";
import GetInTouch from "../components/getInTouchComponent/getInTouchComponent";
import "./styles.scss";
import TestimonialsTravala from "../components/testimonialsTravala/testimonialTravala";
import CorporateManagementContent from "../components/corporateManagementComponents/corporateManagementContent";

const CorporateManagementPage = () => {
  return (
    <div className="main-layout-container ">
      <ImgBackground
        insideText={"Corporate Management"}
        imgPath={BackgroundImg}
      />
      <CorporateManagementContent />
      <GetInTouch />
      {/* <TestimonialsTravala /> */}
    </div>
  );
};

export default CorporateManagementPage;
